import {useTranslation} from 'react-i18next';
import {ExternalLink} from 'lucide-react';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import {goToExternalLink} from 'utils/common';
import {usePartnerHandoffStore} from './usePartnerHandoffStore';

function PartnerHandoffModal() {
  const {t} = useTranslation();
  const pendingUrl = usePartnerHandoffStore(state => state.pendingUrl);
  const dismissHandoff = usePartnerHandoffStore(state => state.dismissHandoff);

  const handleContinue = () => {
    if (pendingUrl) goToExternalLink(pendingUrl);
    dismissHandoff();
  };

  return (
    <ResponsiveSheet
      open={Boolean(pendingUrl)}
      onClose={dismissHandoff}
      title={t('partner_handoff.title')}
      dialogClassName="max-w-[460px] sm:max-w-[460px]"
      closeOnOverlayClick
    >
      <div className="flex flex-col gap-5">
        <p className="text-[13px] leading-[19px] text-[color:var(--chekin-text-secondary)]">
          {t('partner_handoff.description')}
        </p>

        <div className="flex flex-col gap-3">
          <Button onClick={handleContinue}>
            {t('partner_handoff.continue')}
            <ExternalLink />
          </Button>
          <Button variant="link" tone="quiet" onClick={dismissHandoff}>
            {t('partner_handoff.stay_here')}
          </Button>
        </div>
      </div>
    </ResponsiveSheet>
  );
}

export {PartnerHandoffModal};
